// authSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  user: {
    token: null,
    user_nicename: null,
  },
  isLoading: false,
  isError: false,
  loginError: null,
  registrationError: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.reciteontv.com/wp-json/jwt-auth/v1/token",
        { username: email, password }
      );

      const { token, user_nicename } = response.data;

      // Dispatch actions to update the state
      dispatch(setToken(token));
      dispatch(setUserNicename(user_nicename));

      // Store the token and user_nicename in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user_nicename", user_nicename);
      localStorage.setItem("data", JSON.stringify(response.data));

      return { token, user_nicename };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return rejectWithValue({ message: "Invalid credentials" });
      } else {
        return rejectWithValue({
          message: "An error occurred while logging in",
        });
      }
    }
  }
);

export const register = createAsyncThunk("auth/register", async (user) => {
  if (!user || !user?.username || !user?.email || !user?.password) return null;
  const res = await axios.post(
    `${process.env.REACT_APP_API_ROOT}/register`,
    user
  );
  return res.data;
});

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setToken: (state, action) => {
      state.user.token = action.payload;
    },
    setUserNicename: (state, action) => {
      state.user.user_nicename = action.payload;
    },
    logout: (state) => {
      state.user = {
        token: null,
        user_nicename: null,
      };
      localStorage.removeItem("token");
      localStorage.removeItem("user_nicename");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.isLoading = true;
      state.loginError = null;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.user.token = action.payload.token;
      state.user.user_nicename = action.payload.user_nicename;
      state.isLoading = false;
      state.isError = false;
      state.loginError = null;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.loginError = action.payload.message || "Login failed";
    });

    builder.addCase(register.pending, (state) => {
      state.isLoading = true;
      state.registrationError = null;
    });
    builder.addCase(register.fulfilled, (state, action) => {
      state.user = {
        id: action.payload.id,
        username: action.payload.username,
        email: action.payload.email,
      };
      state.isLoading = false;
      state.isError = false;
      state.registrationError = null;
    });
    builder.addCase(register.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.registrationError = action.payload.message || "Registration failed";
    });
  },
});

export const { setToken, setUserNicename, logout } = authSlice.actions;
export const selectUsername = (state) => state.auth.user?.username;
export const selectUserNicename = (state) => state.auth.user?.user_nicename;
export default authSlice.reducer;
